module.exports = "/_next/static/images/contact@2x-083de9fd0de5ca971cf5816ab2540488.png";